// MainComponent.js
import React, { useState } from "react";
import axios from "axios";

const AI = () => {
  const [input, setInput] = useState("");
  const [completedSentence, setCompletedSentence] = useState("");
  const [processing, setProcessing] = useState(false);

  const fetchData = async () => {
    const response = await axios.post("/api/ai", {
      prompt: `Complete this sentence: "${input}"`,
    });

    return response.data.result;
  };

  async function handleClick() {
    try {
      setProcessing(true); // Start processing
      const completedSentence = await fetchData();
      setCompletedSentence(completedSentence);
    } catch (error) {
      console.error(error);
    } finally {
      setProcessing(false); // Stop processing
    }
  }

  return (
    <div className="max-w-xl p-6 text-vscode-text">
      <h2 className="mb-3 text-sm font-medium text-vscode-textBright">
        Tell me something, and I'll tell you more
      </h2>
      <textarea
        value={input}
        onChange={(event) => setInput(event.target.value)}
        rows={5}
        placeholder="Type in some words and I'll finish the rest..."
        className="w-full rounded-sm border border-vscode-border bg-vscode-input px-2 py-1 text-xs text-vscode-text placeholder:text-vscode-textMuted focus:border-vscode-accent focus:outline-none"
      />
      <button
        onClick={handleClick}
        disabled={processing}
        className="mt-3 rounded-sm bg-vscode-button px-4 py-1.5 text-xs font-medium text-white hover:bg-vscode-buttonHover disabled:opacity-60"
      >
        Complete Sentence
      </button>
      {processing && <p className="mt-2 text-xs text-vscode-textMuted">Processing...</p>}
      {completedSentence && (
        <pre className="mt-3 whitespace-pre-wrap rounded-sm border border-vscode-border bg-vscode-bg p-3 font-mono text-xs">
          Completed sentence: {completedSentence}
        </pre>
      )}
    </div>
  );
};

export default AI;
